import CustomLabel from "../../customUiForCs/CustomLabel";
import LoggedInBoilerplate from "../loggedIn/LoggedInBoilerplate";
import styled from "styled-components";
import CSVUploaderForMigration from "./CSVUploaderForMigration";
import ExcelUploaderForMigration from "./ExcelUploaderForMigration";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 80%;
  align-items: center;
  margin-top: 50px;
`;

const options = [{ value: "SITE" }];

export default function Migration() {
  let title1 = "La page";
  let title2 = "de Migration";

  return (
    <LoggedInBoilerplate titleLine1={title1} titleLine2={title2}>
      <Container>
        <ExcelUploaderForMigration
          suggestedFileName="Locations.xlsx"
          title={"Step 1. Populate Zones"}
          message={"Upload the csv for locations"}
          path={"/populate-zones"}
        />
        <ExcelUploaderForMigration
          suggestedFileName="Locations.xlsx"
          title={"Step 2. Populate Sites"}
          message={"Upload the csv for locations"}
          collectionName={"SITE"}
          path={"/migration"}
        />
        <ExcelUploaderForMigration
          suggestedFileName="Assistance.xlsx"
          title={"Step 3. Populate Assistance Of Site"}
          message={"Upload the csv for locations with assistance"}
          path={"/populate-assistance-of-site"}
        />
        <ExcelUploaderForMigration
          suggestedFileName="Contracts.xlsx"
          title={"Step 4. Populate Contracts Of Site"}
          message={"Upload the csv for locations with contracts"}
          path={"/populate-contracts-of-site"}
        />
        <br />
        <ExcelUploaderForMigration
          suggestedFileName="Personnel.xlsx"
          title={"Step 5. Populate Profiles"}
          message={"Upload the csv for Personnel"}
          collectionName={"PROFILE"}
          path={"/migration"}
        />
        <ExcelUploaderForMigration
          suggestedFileName="Personnel.xlsx"
          title={"Step 6. Populate Profiles With Inactive Users"}
          message={"Upload the csv for Personnel"}
          collectionName={"PROFILE"}
          path={"/migration?usersAreInactive=true"}
        />
        <ExcelUploaderForMigration
          suggestedFileName="Personnel.xlsx"
          title={"Step 7. Populate Comments"}
          message={"Upload the csv for employees"}
          collectionName={"COMMENT"}
          path={"/migration"}
        />

        <br />
        <ExcelUploaderForMigration
          suggestedFileName="Absence.xlsx"
          title={"Step 8. Populate Absence"}
          message={"Upload the csv for employees with absence"}
          collectionName={"ABSENCE"}
          path={"/migration"}
        />

        <ExcelUploaderForMigration
          suggestedFileName="Conges.xlsx"
          title={"Step 9. Populate Vacations"}
          message={"Upload the csv for employees with vacation"}
          collectionName={"VACATION"}
          path={"/migration"}
        />

        <ExcelUploaderForMigration
          suggestedFileName="Contentieux.xlsx"
          title={"Step 10. Populate Disputes"}
          message={"Upload the csv for locations"}
          collectionName={"DISPUTE"}
          path={"/migration"}
        />

        <ExcelUploaderForMigration
          title={"Step 11. Populate Search & Assignment For Employee's"}
          path={"/populate-search-and-assignment"}
          dataNotRequired={true}
        />
        <ExcelUploaderForMigration
          title={"Step 12. Populate Search For Site"}
          path={`/populate-search/?collectionName=SITE`}
          dataNotRequired={true}
        />
        <ExcelUploaderForMigration
          title={"Step 13. Populate Search For Absence"}
          path={`/populate-search/?collectionName=ABSENCE`}
          dataNotRequired={true}
        />
        <ExcelUploaderForMigration
          title={"Step 14. Populate Search For Dispute"}
          path={`/populate-search/?collectionName=DISPUTE`}
          dataNotRequired={true}
        />
        <ExcelUploaderForMigration
          title={"Step 15. Populate Search For Vacation"}
          path={`/populate-search/?collectionName=VACATION`}
          dataNotRequired={true}
        />
        <ExcelUploaderForMigration
          title={"Step 16. Populate Search For Comment"}
          path={`/populate-search/?collectionName=COMMENT`}
          dataNotRequired={true}
        />

        <ExcelUploaderForMigration
          title={"Step 17. Populate Personnel Count"}
          path={`/populate-personnel-count`}
          dataNotRequired={true}
        />

        <ExcelUploaderForMigration
          title={"Step 18. Populate Search For Zone"}
          path={`/populate-search/?collectionName=ZONE`}
          dataNotRequired={true}
        />
      </Container>
    </LoggedInBoilerplate>
  );
}
